(function () {
  'use strict';
  function bind(bar) {
    if (bar.dataset.psStickyReady === 'true') return;
    bar.dataset.psStickyReady = 'true';
    var scope = bar.closest('.sec__featured-product') || bar.closest('[id^="shopify-section-"]') || document;
    var button = bar.querySelector('[data-ps-sticky-submit]');
    var selection = bar.querySelector('[data-ps-sticky-selection]');
    var price = bar.querySelector('[data-ps-sticky-price]');
    var activeWidget = null;
    function money(cents, currency) {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
    }
    function update(widget, state) {
      if (!state || String(state.productId) !== bar.dataset.productId) return;
      activeWidget = widget;
      var unit = state.quantity === 1 ? state.unit : state.unitPlural;
      selection.textContent = (state.items && state.items.length > 1 ? 'Mixed options' : state.variantTitle) + ' · ' + state.quantity + ' ' + unit;
      price.textContent = state.priceConfirmed === false ? 'Bundle price unavailable' : money(state.totalCents, state.currency) + ' total' + (state.unitPriceCents == null ? ' · ' + (state.unitPrices || []).map(function (unitPrice, index) { return '#' + (index + 1) + ' ' + money(unitPrice, state.currency) + ' each'; }).join(' · ') : ' · ' + money(state.unitPriceCents, state.currency) + ' each');
      button.disabled = !state.available;
      button.textContent = state.available ? 'Add ' + state.quantity + ' ' + unit + ' · ' + money(state.totalCents, state.currency) + ' total' : state.priceConfirmed === false ? 'Bundle price unavailable' : 'Selected option unavailable';
    }
    scope.addEventListener('ps:bundle:change', function (event) { update(event.target, event.detail); });
    scope.querySelectorAll('.vdb-widget').forEach(function (widget) { if (widget.psBundleState) update(widget, widget.psBundleState); });
    button.addEventListener('click', function () {
      if (!activeWidget || !activeWidget.psBundleState || !activeWidget.psBundleState.available || typeof activeWidget.psBundleSubmit !== 'function') return;
      activeWidget.psBundleSubmit();
    });
  }
  function boot(root) { (root || document).querySelectorAll('[data-ps-bundle-sticky]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
